import { TranslationTypes } from "../../types/translationTypes";

const en: TranslationTypes = {
  toggleLanguage: "pt-BR",
  presentationOne: "Hi, my name is",
  presentationTwo: "Felipe França",
  presentationTree: "It's a pleasure to have you interested in my work.",
  skills: "I'm a Full Stack developer & UX/UI designer",
  seeProjects: "See my projects",
  knowMore: "About me",

  aboutMe: "About me",
  aboutMeDescOne: "Full stack developer with 3 years of experience, focused on creating accessible and responsive systems. My journey began in 2022, when I made a career transition from technical support to web development.",
  aboutMeDescTwo: "Since then, I have been working hard and constantly seeking personal improvement, falling more and more in love with what I do. I have experience with Javascript-derived technologies, especially TypeScript, React and Next, and also with PHP for Apache hosting. On the backend, I have experience with Node, Nest, Java and C++. In addition, I work with the creation of Docker images and management of relational databases for application deployment.",
  aboutMeDescTree: "It is also important to highlight my interest in audiovisual production as a hobby, in which I use tools such as Photoshop and DaVinci Resolve. This experience contributes positively to my work with frontend development, especially in visual and usability aspects.",
  resume: "See my resume",
  resumeWay: "/ffResumeEN.pdf",

  home: "HOME",
  projects: "PROJECTS",
  about: "ABOUT ME",
  contact: "CONTACT",
  github: "GitHub",
  linkedin: "LinkedIn",

  info: "Expand",
  error: "ERROR",
  backToHome: "Back to home",

  socialMedia: "Social Media",

  projectLinkDesc: "Link to repository: ",

  projectsTitle1: "Single page system for calculating BMR and food control, based on daily calories",
  projectsDate1: "30/05/2025",
  projectsDescription1: "This project was initially developed to meet a personal need: to organize the macronutrients of daily consumption with the aim of maintaining a balanced diet, without directly relying on a nutritionist. However, it is worth noting that the application does not replace professional monitoring, as its effective use requires prior knowledge of nutrition to structure a sustainable diet. Available online at: https://felipefrancca.github.io/dieta-facil/",
  
  projectsTitle2: "Sales flow control system",
  projectsDate2: "11/12/2024",
  projectsDescription2: "The objective of the project is to enable the creation of sales and the requirements to meet a specific sale. The requirements are met by generating a purchase, where products must be previously added to the system, to take them to the cart and then generate a purchase related to a specific sale.",
  
  projectsTitle3: "Public API consumption",
  projectsDate3: "07/24/2024",
  projectsDescription3: "Practicing API consumption containing a list of characters from the film Start Wars, where there is public and private information, making it possible to access private information through a login with modified data. Available online at: https://felipefrancca.github.io/listOfCharacters/",
  
  projectsTitle4: "Fake Trello",
  projectsDate4: "04/05/2024",
  projectsDescription4: "Kanban project developed in React.js to put drag and drop skills into practice with a layout based on the Trello website. Available online at: https://felipefrancca.github.io/fakeTrello/",

  projectsTitle5: "Login Page",
  projectsDate5: "10/28/2023",
  projectsDescription5: "A simple login page created to practice design and user interface skills. Available online at: https://felipefrancca.github.io/loginPage/",
};

export default en;
